import { createSlice } from "@reduxjs/toolkit";
import { getProgramList, getProgramDetail, saveProgram, deleteProgram } from "../controller/program.controller";
import { Program } from "../types/programType";
import { SaveResponse } from "../types/common";

interface ProgramState {
  loading: boolean;
  list: Program[];
  total: { pages: number; data: number };
  detail: Program | null;
  detailLoading: boolean;
  response: SaveResponse | null;
  error: string | null;
}

const initialState: ProgramState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  detail: null,
  detailLoading: false,
  response: null,
  error: null,
};

const programSlice = createSlice({
  name: "program",
  initialState,
  reducers: {
    resetProgramResponse: (state) => {
      state.response = null;
    },
    resetProgramDetail: (state) => {
      state.detail = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProgramList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProgramList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getProgramList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data program";
      })
      .addCase(getProgramDetail.pending, (state) => {
        state.detailLoading = true;
        state.detail = null;
      })
      .addCase(getProgramDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.detail = action.payload.data ?? null;
      })
      .addCase(getProgramDetail.rejected, (state, action) => {
        state.detailLoading = false;
        state.error = action.error.message ?? "Gagal memuat detail program";
      })
      .addCase(saveProgram.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveProgram.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan program";
      })
      .addCase(deleteProgram.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetProgramResponse, resetProgramDetail } = programSlice.actions;
export default programSlice.reducer;
